import baseURL from "../config";
import {
    Box,
    Button,
    TextField,
    FormControl,
    InputLabel,
    NativeSelect,
    useTheme,
    Select,
    IconButton,
  MenuItem
  } from "@mui/material";
  import { Formik } from "formik";
  import * as yup from "yup";
  import useMediaQuery from "@mui/material/useMediaQuery";
  import Header from "../Components/Header";
  import { Link, useNavigate } from "react-router-dom";
  import axios from "axios";
  import { ToastContainer, toast } from "react-toastify";
  import "react-toastify/dist/ReactToastify.css";
  import { tokens } from "../theme";
  import KeyboardReturnOutlinedIcon from "@mui/icons-material/KeyboardReturnOutlined";
  import { useEffect, useState } from "react";
  import * as React from "react";
  import Radio from "@mui/material/Radio";
  import RadioGroup from "@mui/material/RadioGroup";
  import FormControlLabel from "@mui/material/FormControlLabel";
  import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
    import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
  import Tooltip from '@mui/material/Tooltip';
  import Cookies from "js-cookie";
  import CryptoJS from "crypto-js";

  
  const OfferForm = () => {
    const theme = useTheme();
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const isTablet = useMediaQuery("(min-width:1175px");
    const colors = tokens(theme.palette.mode);
    const notifyError = () => toast.error("This brand doesn't exist");
    const getDecryptedToken = () => {
      const encryptedToken = Cookies.get("token");
      if (!encryptedToken) return null;
  
      const secretKey = '19092002'; 
      const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
      const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
  
      return decryptedToken || null;
    };
  
   
    const token = getDecryptedToken();
    const [offerData, setOfferData] = useState();
    const [brands, setBrands] = useState([]); 
    const [imageData, setImageData] = useState({
      image:""
    })

    useEffect(() => {
    
      const fetchBrands = async () => {
        try {
          const response = await axios.get(`${baseURL}/api/Brands/GetBrands`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if(response.data.success){
              const brands = response.data.brands;
          setBrands(brands);
          }
        } catch (error) {
          console.error("Error fetching brands:", error);
        }
      };
  
      fetchBrands();
    }, [token]);

    const handleFileUpload = (file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageData((prevData) => ({
          ...prevData,
          image: reader.result.split(",")[1], // Base64 image
        }));
      };
      reader.readAsDataURL(file);
    };

    const navigate = useNavigate();
  
    const style = {
      radiobutton: {
        float: "right",
      },
    };

    const handleFormSubmit = async (values, actions) => {
      try {
           await axios.post(
            `${baseURL}/api/Offers/CreateOffer`,
            {
              offerId: 0,
              description: values.Description ,
              content: values.Content,
              startDate: values.StartDate ,
              endDate: values.EndDate ,
              image: imageData.image , 
              brandId: values.BrandId ,
            },    
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
      navigate("/offers");
    } catch (error) {
      if (error.response) {
        
        actions.resetForm();
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log("Error", error.message);
      }
    }
  };
  
    return (
      <Box m="20px">
        <ToastContainer hideProgressBar={true} autoClose={2000} />
        <Header title="Shto Oferte" subtitle="Plotesoni te dhenat per oferte" />
        <Link to="/offers" style={{ textDecoration: "none" }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: colors.primary[700], marginBottom: 2 }}
          >
            <KeyboardReturnOutlinedIcon />
            Tabela e Ofertave
          </Button>
        </Link>

        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setValues,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
            
              <LocalizationProvider dateAdapter={AdapterDayjs}>
             <DateTimePicker
              label="Start Date"
              value={values.StartDate || null}
              sx={{ gridColumn: "span 2" }}
              onChange={(newValue) => setFieldValue("StartDate", newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  variant="filled"
                  name="StartDate"
                  error={!!touched.StartDate && !!errors.StartDate}
                  helperText={touched.StartDate && errors.StartDate}
                />
              )}
            />

              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                label="End Date"
                value={values.EndDate || null}
                sx={{ gridColumn: "span 2" }}
                onChange={(newValue) => setFieldValue("EndDate", newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    variant="filled"
                    name="EndDate"
                    error={!!touched.EndDate && !!errors.EndDate}
                    helperText={touched.EndDate && errors.EndDate}
                  />
                )}
              />

              </LocalizationProvider>

                <Box display="flex" alignItems="center" sx={{ gridColumn: "span 2" }}>
              <TextField
                
                type="file"
                onChange={(e) => handleFileUpload(e.target.files[0])}
                fullWidth
                margin="dense"
                inputProps={{
                  accept: "image/*", 
                }}
              />
              <Tooltip title="Image should be 771x170 for the best quality" arrow>
              <IconButton>
                  <i className="fas fa-info-circle" style={{ color: colors.primary[900] }}></i>
                </IconButton>
              </Tooltip>
            </Box>
                <TextField
                  fullWidth
                  variant="filled"
                  label="Description"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  name="Description"
                  value={values.Description}
                  error={!!touched.Description && !!errors.Description}
                  sx={{ gridColumn: "span 2" }}
                />

                <TextField
                  fullWidth
                  variant="filled"
                  label="Content"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  name="Content"
                  value={values.Content}
                  error={!!touched.Content && !!errors.Content}
                  sx={{ gridColumn: "span 2" }}
                />
                 <FormControl
                fullWidth
                variant="filled"
                sx={{ gridColumn: "span 2" }}
              >
                <InputLabel>ID e Brendit</InputLabel>
                <Select
                  value={values.BrandId || ''}
                  onChange={(e) => setFieldValue("BrandId", e.target.value)}
                  onBlur={handleBlur}
                  name="BrandId"
                  error={!!touched.BrandId && !!errors.BrandId}
                >
                  {brands.map((brand) => (
                    <MenuItem key={brand.brandId} value={brand.brandId}>
                      {`${brand.brandId} - ${brand.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
                <Box sx={{ gridColumn: "span 4" }}>
                  {" "}
                  <hr
                    style={{
                      border: "none",
                      height: "2px",
                      backgroundColor: "white",
                      margin: "0",
                      padding: "0",
                    }}
                  />
                </Box>   
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button type="submit" style={{ backgroundColor: colors.primary[700]}} variant="contained">
                Shto Oferten
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    );
  };
  
  
  const checkoutSchema = yup.object().shape({
 
    // Description: yup.string().required("Description is required!"),
   
    // StartDate: yup.date().nullable().required("Start Date is required!"),
    // EndDate: yup.date()
    //   .nullable()
    //   .required("End Date is required!")
    //   .min(yup.ref("startDate"), "End Date must be after Start Date!"),
    //   Image: yup.string().required("Image is required!"),
    //   BrandId: yup.string().required("Brand ID is required!"),
  });
  

  const initialValues = {
    OfferId: 0,
    Description: '',
    Content: '',
    StartDate: null,
    EndDate: null,
    Image: '',
    BrandId: '1',
  };
  
  
  export default OfferForm;